import { createAsyncThunk } from '@reduxjs/toolkit';

import { type PapelAtribuivel, usuarioPapelAdminService } from './services';

export const alterarPapelUsuario = createAsyncThunk(
  'usuarioPapelAdmin/alterar',
  async (
    { usuarioId, papel }: { usuarioId: string; papel: PapelAtribuivel },
    { rejectWithValue },
  ) => {
    try {
      return await usuarioPapelAdminService.alterar(usuarioId, papel);
    } catch (error) {
      return rejectWithValue((error as Error).message);
    }
  },
);
